import commonInstance from "../instance/commonInstance";

class AppSettingsApi {
  static async fetchAppSettings(locale) {
    try {
      const params = locale ? { locale } : {};
      const response = await commonInstance.get("/app-settings", { params });
      const body = response?.data;
      if (body?.data) {
        return body.data;
      }
      if (body) {
        return body;
      }
    } catch (error) {
      return null;
    }
  }
}

export default AppSettingsApi;
